import React from "react";
import Navigation from "../component/Navigation";
import Contact from "../component/Contact";

const Policy = () => {
	return (
		<div className="cover-page">
			<div className="row">
				<div className="col-lg-8">
					<div className="urb-page">
						<Navigation />
						<div className="content-fill">
							<div className="container">
								<h5 className="title">Privacy Policy</h5>
								<div className="policy mt-4">
									<h6>Our Commitment to You</h6>
									<p>
										Urbco Limited (“Urbco”) respects your
										privacy and is committed to protecting
										personal information collected from you
										through our website. This privacy policy
										governs the way we collect and use
										information, and by using the services
										on our website ('Services') you agree to
										be bound by this policy. All references
										within this policy to 'we/us/our' refer
										to Urbco.
									</p>
									<h6>Information We Collect</h6>
									<p>
										When you use the Services you will have
										the option to provide us with personal
										information, such as your email address,
										so that we may keep you informed. We use
										this information only in response to
										your requests and to provide the
										Services.
									</p>
									<p>
										When visiting our website, we may place
										one or more cookies (a small file that
										is stored by your browser to recognize
										you and store your preferences) on your
										computer. This helps us to improve our
										Services by personalizing the
										information you may want. You may adjust
										the settings on your browser to refuse
										cookies but some of the Services may not
										work if you do so. We may also log
										information from your computer including
										the existence of cookies, your IP
										address, and information about your
										browser program to allow us to diagnose
										problems, and administer and track your
										usage of the Services.
									</p>
									<h6>What is Personal data?</h6>
									<p>
										Personal data is any information that
										can be used in identifying a natural
										individual. This could include
										information such as name, contact
										details such as telephone number, date
										of birth, address, or any information
										about your needs or circumstances which
										would allow us to identify you.
									</p>
									<p>
										Your data is used as is appropriate in
										the normal course of our business with
										you to provide the products and services
										you have requested. With your consent,
										we will only retain any information for
										purposes of ongoing business
										relationships or to communicate directly
										with you.
									</p>
									<h6>
										The types of Personal Data we collect
									</h6>
									<p>
										We may sometimes collect your name and
										contact details (such as phone number
										and email address) from you whenever you
										contact us to enable us to provide our
										services. Depending on the service that
										we provide to you (or on your behalf) we
										may also collect additional Personal
										Data as detailed below;
									</p>
									<p>Buy, Sell, Let, Rent</p>
									<ul>
										<ol type="a">
											<li>
												If you are selling or letting a
												property through us;
												<ul>
													<li>
														We will collect a
														contact telephone number
														to get in touch with you
														about organizing
														viewings and updating
														you on any offers
														received or rental
														applications for your
														property.
													</li>
													<li>
														Where you are not the
														legal owner of the
														property we will request
														details from you as to
														your ability to sell or
														let the property such as
														a Power of Attorney.
													</li>
												</ul>
											</li>
											<li>
												If you wish to purchase a
												property we are listing for
												sale, we will collect Personal
												data relating to any specific
												requirements you may have about
												a property so that we can find a
												property that is suitable for
												your needs. We will also collect
												the Personal data required to
												source a property for you and,
												where required, negotiate the
												purchase of a property on your
												behalf.
												<br />
												<br />
												<p>Facilities Management</p>
											</li>
											<li>
												Where we are managing property
												on your behalf we may need to
												pass your data on to third-party
												contractors whom we have engaged
												to carry out maintenance on your
												properties.
												<br />
												<br />
												<p>Regulatory compliance</p>
											</li>
											<li>
												To comply with certain
												regulatory requirements, we will
												collect information required to
												identify you to meet anti-money
												laundering and counter-terrorist
												financing requirements. We will
												collect information relating to
												your identity, which will
												include at least one form of
												photographic identification
												(such as a passport, a driving
												license, or an identification
												card) and one form of
												documentation with proof of your
												place of residence (such as a
												recent utility bill).
											</li>
											<li>
												If you are an entity such as a
												company, trust, or charity, we
												may need to collect Personal
												data about the controllers and
												the beneficiaries of the entity.
												<br />
												<br />
												<p>Other</p>
											</li>
											<li>
												If you subscribe to receive
												research, news, or other market
												updates from us, then in
												addition to the above we will
												collect details such as email
												address and the type of content
												that you would like to receive.
											</li>
											<li>
												We collect personal details such
												as images and video recordings
												through CCTV where you are
												present in our facilities and in
												facilities we manage for our
												clients.
											</li>
											<li>
												We maintain a list of e-mail
												addresses to which Urbco Limited
												Newsletter is sent. Individuals
												must affirmatively request to
												join this list by using the
												subscribe form on the
												subscriptions page. Any members
												of this list may choose to
												unsubscribe at any time by using
												the same form. Our list server
												has been configured in such a
												way that the e-mail addresses
												can only be accessed by
												authorized Urbco Limited staff.
												We will only record your e-mail
												address if you send us a
												message. It will only be used
												for the purpose for which you
												provide it and will not be added
												to a mailing list unless you
												request that this be done. We
												will not disclose it without
												your consent.
											</li>
											<li>
												We may also collect the
												following:
												<ul>
													<li>
														Account or profile
														information when you
														connect with us on our
														social media platforms;
													</li>
													<li>
														Other publicly available
														personal data, including
														any which you have
														shared via a public
														platform (such as a
														LinkedIn, Twitter, or
														Facebook page);
													</li>
													<li>
														Job application personal
														data when you apply for
														any of our vacancies
														advertised including
														contact details, work
														history, employment
														needs and interests, and
														anything relevant to the
														job for which you are
														applying; and
													</li>
													<li>
														Information about your
														computer, including
														where available your IP
														address, operating
														system, and browser
														type. This is
														statistical data about
														our users' browsing
														actions and patterns,
														that does not identify
														any individual.
													</li>
												</ul>
											</li>
										</ol>
									</ul>
									<p>
										Our website is not intended for children
										and we do not knowingly collect data
										relating to children.
									</p>
									<h6>How we collect your personal data</h6>
									<p>
										We use different methods to collect data
										from and about you. Our legal channels
										of information collection are itemized
										below:
									</p>
									<ul>
										<ol>
											<li>
												<p>
													Direct interactions: We
													collect your data through
													the direct provision of data
													in the course of your use of
													our services with your
													consent. We collect
													information about your use
													of our website and services
													through our analytics
													tracking system to carry out
													our legitimate interests in
													monitoring and improving our
													website and services.
												</p>
												<p>
													You may give us your data by
													filling in forms or by
													corresponding with us by
													post, phone, email, or
													otherwise.
												</p>
											</li>
											<li>
												<p>
													Use of technology and
													automated interactions: We
													collect your data through
													the direct provision of data
													in the course of your use of
													our services with your
													consent. As you interact
													with our website, we will
													automatically collect
													technical data about your
													equipment, browsing actions,
													and patterns. We collect
													this personal data by using
													cookies and other similar
													technologies.
												</p>
												<p>
													Cookies are small files
													placed on your computer’s
													hard drive that enables the
													website to identify your
													computer as you view
													different pages. Cookies
													allow websites and
													applications to store your
													preferences to present
													contents, options, or
													functions that are specific
													to you. Like most
													interactive websites, our
													website uses cookies to
													enable the tracking of your
													activity for the duration of
													a session. Our website uses
													only encrypted session
													cookies which are erased
													either after a predefined
													timeout period or once the
													user logs out of the
													platform and closes the
													browser. Session cookies do
													not collect information from
													the user’s computer. They
													will typically store
													information in the form of a
													session identification that
													does not personally identify
													the user.
												</p>
												<p>
													We may collect your personal
													data such as recorded images
													from the technology we use
													in our offices and
													facilities we manage, such
													as security cameras (CCTV)
													and visitor management
													systems. We operate cameras
													for security and operational
													purposes.
												</p>
											</li>
											<li>
												<p>
													Third Parties: We may also
													receive your personal data
													from third parties to whom
													you have legally provided
													such information to, and we
													may use such information in
													accordance with our
													policies.
												</p>
												<p>
													To the extent that such data
													is disclosed by third
													parties, whether our
													clients, service providers,
													or advertisers on other
													sites throughout the
													Internet, different rules
													may apply to their use or
													disclosure of your
													information. We do not
													control how they use or
													share your data and we
													cannot make any
													representations or
													warranties as to these.
												</p>
												<p>
													Web pages on our website may
													contain cookies or related
													technology to support your
													experience and enable our
													systems to recognize your
													browser or device. These
													cookies are text files
													placed in your computer's
													internet browser to store
													your preferences.
												</p>
											</li>
										</ol>
									</ul>
									<h6>
										The legal basis for processing your
										personal data
									</h6>
									<p>
										Under data protection legislation we are
										only permitted to use your Personal data
										if we have a legal basis for doing so.
										We rely on the following legal bases to
										use your information;
									</p>
									<ul>
										<li>
											Where we have received consent from
											you
										</li>
										<li>
											Where we need information to perform
											the contract we have entered into
											with you
										</li>
										<li>
											Where we need to comply with a legal
											obligation
										</li>
										<li>
											Where we need to protect your
											interests (or someone else's
											interests); and/or
										</li>
										<li>
											Where it is needed in the public
											interest or for official purposes
											<br />
											<br />
											We may process special categories of
											Personal data and criminal
											conviction information in the
											following limited circumstances:
										</li>
										<li>
											With your explicit consent, in which
											case we will explain the purpose for
											which the information will be used
											at the point where we ask for your
											consent.
											<br />
											<br />
											What constitutes consent
										</li>
										<li>
											Consent of the data subject means
											any freely given, specific,
											informed, and unambiguous indication
											of the data subject’s wishes by
											which he or she, by a statement or
											by clear affirmative action,
											signifies agreement to the
											processing of personal data relating
											to him or her.
										</li>
										<li>
											You have the right to withdraw your
											consent at any time.
											<br />
											<br />
											How we keep your information secure
											<br />
											The security of information is very
											important to us and we have measures
											in place (physical, technical, and
											administrative security measures)
											that are designed to reduce the risk
											of loss, misuse, disclosure, and
											unauthorized access to your Personal
											data including but not limited to:
										</li>
										<li>
											Use of firewalls and data
											encryption.
										</li>
										<li>
											Storage of files on our secure
											systems. Access is restricted on our
											client systems to those within the
											business who are required to have
											access to your information.
										</li>
										<li>
											Hard copy documentation is stored in
											locked cabinets
											<p>
												We ensure access to Personal
												data is restricted to Urbco
												employees and workers or other
												persons working within the Urbco
												Group on a need-to-know basis.
												Training on data protection is
												provided to any of those Urbco
												employees and workers who need
												access to Personal data.
											</p>
										</li>
									</ul>
									<h6>How long we keep your Personal data</h6>
									<p>
										Whenever we collect or process your
										personal data, we’ll only keep it for as
										long as is necessary for the purpose for
										which it was collected. At the end of
										the necessary period, we will either
										delete your data completely or anonymize
										your data so that it can be used in a
										non-identifiable way for statistical
										analysis and business planning. You may
										request information on whether your data
										has been deleted or anonymized.
									</p>
									<p>
										In some cases, we may hold your data
										longer where we have statutory or
										regulatory obligations to retain
										Personal data for a longer period, or
										where we may need to retain the
										information in case of a legal claim.
									</p>
									<h6>
										Your rights in relation to your Personal
										data
									</h6>
									<p>
										You have a number of rights in relation
										to your Personal data, these include the
										right to:
									</p>
									<ul>
										<li>
											Be informed about how we use your
											Personal data.
										</li>
										<li>
											Obtain access to your Personal data
											that we hold.
										</li>
										<li>
											Request that your Personal data be
											corrected if you believe it is
											incorrect, incomplete, or
											inaccurate.
										</li>
										<li>
											Request that we erase your Personal
											data in the following circumstances:
											<ul>
												<li>
													If Urbco is continuing to
													process Personal data beyond
													the period when it is
													necessary to do so for the
													purpose for which it was
													originally collected.
												</li>
												<li>
													If Urbco is relying on
													consent as the legal basis
													for processing and you
													withdraw consent.
												</li>
												<li>
													If the Personal data has
													been processed unlawfully
													(i.e. in breach of the
													requirements of the data
													protection legislation).
												</li>
												<li>
													If it is necessary to delete
													the Personal data to comply
													with a legal obligation.
												</li>
											</ul>
										</li>

										<li>
											Ask us to restrict our data
											processing activities where you
											consider that:
											<ul>
												<li>
													Personal data is inaccurate.
												</li>
												<li>
													Our processing of your
													Personal data is unlawful.
												</li>
												<li>
													Where we no longer need the
													Personal data but you
													require us to keep it to
													enable you to establish,
													exercise or defend a legal
													claim.
												</li>
												<li>
													Where you have objected to
													our use of your Personal
													data.
												</li>
											</ul>
										</li>
										<li>
											Request a copy of certain Personal
											data that you have provided to us in
											a commonly used electronic format.
											This right relates to Personal data
											that you have provided to us that we
											need to perform our agreement with
											you and Personal data where we are
											relying on consent to process your
											Personal data.
										</li>
										<li>
											to be informed of wholly automated
											decision-making, the logic behind
											it, and the resultant effect it
											could have on you.
										</li>
									</ul>
									<p>
										If you would like to exercise any of
										your rights you may submit your request
										via our ____ Request form saved on our
										website and send the form to
										_____@Urbco.ng.
									</p>
									<p>
										Upon a request made, we will provide you
										with details of the Personal data we
										hold about you. Should you believe that
										any information we hold about you is
										incorrect, please inform us at the above
										email address and we will correct it.
									</p>
									<p>
										Please note that we will keep a record
										of the fact that you have requested to
										exercise your rights, and our response
										to your request, to demonstrate
										compliance with our data protection
										obligations and so that we can handle
										any queries, complaints or claims about
										your request. This record will be kept
										in accordance with our retention
										policies as explained above.
									</p>
									<p>
										Please note that, while all attempts are
										made to secure information transmitted
										to this Web Site, if you are submitting
										personal details or other information
										over the Internet which you wish to
										remain private, there is a possibility
										that the information you submit could be
										observed by a third party while in
										transit.
									</p>
									<h6>
										Transferring your personal data outside
										of Nigeria:
									</h6>
									<p>
										We store and process your Personal data
										on our computers in Nigeria however we
										may sometimes share your personal data
										with our parent company based in some
										other country via our online software
										throughout our operational activities in
										providing our services to you. We may
										also share your personal data with
										affiliated entities located in other
										countries where it is necessary for the
										provision of our services to you. Where
										we need to transfer your data to another
										country, we will always ensure that such
										country must have an adequate data
										protection law.
									</p>
									<h6>How we use your personal data</h6>
									<p>
										With your consent, we use your personal
										data to fulfill requests to receive
										information or materials from us, to
										carry out services for your benefit and
										to process applications and requests
										from you.
									</p>
									<p>
										Specifically, we use your personal
										information to fulfil our obligations to
										you to let or sell your property or, if
										you are a buyer or tenant, to arrange a
										contract for sale or a lease for you.
									</p>
									<p>
										We do not use your information for any
										other purpose than for the purposes
										listed in this privacy policy and we do
										not sell, lend or rent any personal
										information about you to any third
										parties outside of Urbco Nigeria.
									</p>
									<h6>How we share your personal data</h6>
									<p>
										We may share your personal data in the
										following ways:
									</p>
									<ul>
										<li>
											With Governmental bodies,
											regulators, law enforcement
											agencies, courts/tribunals, and
											insurers, where we are required to
											do so
										</li>
										<li>
											To comply with our regulatory and
											legal obligations;
										</li>
										<li>
											To exercise our legal rights (for
											example in court cases);
										</li>
										<li>
											To do so for the prevention,
											detection, investigation of crime or
											prosecution of offenders;
										</li>
										<li>
											For the protection of our employees
											and customers; and
										</li>
										<li>
											In the case of employees, with any
											companies or third parties
											responsible for payment of salary,
											employee benefits or where we have a
											legal duty to do so.
										</li>
										<li>
											With third-party contractors whom we
											have engaged to carry out
											maintenance on your properties.
										</li>
										<li>
											If you are purchasing a property for
											which we are acting as agents, or
											for the sale of a property through
											us, we will share your personal
											information with your appointed
											solicitors and the solicitors acting
											for the other side of the deal as is
											necessary to facilitate the sale or
											purchase
										</li>
										<li>
											Where we are managing property on
											your behalf we may need to pass your
											personal information from time to
											time on to third-party contractors
											whom we have engaged to carry out
											maintenance on your properties.
										</li>
										<li>
											If we sell any part of our business
											and/or integrate it with another
											organization your details may be
											disclosed to our advisers and
											prospective purchasers or joint
											venture partners and their advisers.
											If this occurs the new owners of the
											business will only be permitted to
											use your information in the same or
											similar way as set out in this
											privacy policy.
										</li>
									</ul>
									<p>
										Where we share your information, we will
										ensure to communicate our data
										protection policy to the party receiving
										your information and endeavor to inform
										them of their obligations concerning
										your information. We cannot, however, be
										responsible for how they use your
										information and we disclaim any
										liabilities for their use of your
										information.
									</p>
									<p>
										We will never share our customer data
										with other organizations for their
										marketing purposes.
									</p>
									<h6>Communicating with You</h6>
									<p>
										If you prefer not to receive emails
										about our Services, you may opt out of
										such communications by following the
										instructions at the bottom of any of our
										emails, or by mailing us via
										support@urbco.ng
									</p>
									<h6>Third Parties</h6>
									<p>
										We use third parties to serve
										advertisements on our website and these
										third parties may use cookies or other
										means to help measure the effectiveness
										of their advertisements. Our website may
										also include links to other unrelated
										websites and/or contact forms to other
										unrelated parties which may collect
										personal information. Our privacy policy
										does not extend to these third parties
										or other websites and we recommend that
										users refer directly to these parties
										regarding their privacy policies before
										supplying personal details to these
										companies.
									</p>
									<h6>Safety and Security</h6>
									<p>
										Personal information is processed and
										stored in our databases and we have
										taken reasonable steps to secure and
										protect the information under our
										control, including establishing
										processes to prevent unauthorized access
										or disclosure of this information.
										However, whilst we make every effort to
										ensure the security of your information,
										we are unable to guarantee the
										protection of the information from
										misuse, accidental disclosure, or
										unauthorized acts by others. Information
										provided by you may be stored or
										processed outside Nigeria.
									</p>
									<h6>Changes to Privacy Policy</h6>
									<p>
										We reserve the right to change this
										privacy policy at any time without prior
										notice to you. Any changes will be
										posted on our website and become
										effective at the time of posting. If
										material changes are made that affect
										the use or disclosure of your personal
										information, we will make reasonable
										efforts to notify you of these changes.
									</p>
									<p>
										If you have any questions or comments
										about our privacy policy, please contact
										us.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-4">
					<div className="contacts sticky-top">
						<Contact />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Policy;
